import { authFetch } from './api';

export const MCP_REQUEST_KEY = 'ub_mcp_request';

export function pendingMcpRequest() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(MCP_REQUEST_KEY) || 'null');
    if (saved && /^[A-Za-z0-9_-]{43}$/.test(saved.request) && saved.createdAt <= Date.now() && Date.now() - saved.createdAt < 600000) return saved.request;
    sessionStorage.removeItem(MCP_REQUEST_KEY);
  } catch { /* missing or blocked browser storage */ }
  return null;
}

export function clearMcpRequest() {
  try { sessionStorage.removeItem(MCP_REQUEST_KEY); } catch { /* no persistent state */ }
}

export function saveMcpRequest(request) {
  if (!/^[A-Za-z0-9_-]{43}$/.test(request)) throw new Error('MCP_REQUEST_FAILED');
  sessionStorage.setItem(MCP_REQUEST_KEY, JSON.stringify({ request, createdAt: Date.now() }));
}

export function mcpErrorKey(error) {
  if (error.message === 'MCP_UNAVAILABLE') return 'mcp_unavailable';
  if (error.message === 'INVALID_REQUEST') return 'mcp_expired';
  return 'mcp_error';
}

export async function mcpApi(path, options = {}) {
  const base = process.env.REACT_APP_API_BASE_URL;
  if (!base) throw new Error('MCP_UNAVAILABLE');
  const response = await authFetch(`${base.replace(/\/$/, '')}/mcp/${path}`, options);
  if (!response) throw new Error('MCP_SESSION');
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    const error = new Error(response.status === 503 ? 'MCP_UNAVAILABLE' : data?.detail?.code || 'MCP_REQUEST_FAILED');
    error.status = response.status;
    throw error;
  }
  return response.json();
}

// Only follow the callback shown on the consent screen, with its original query.
export function validatedMcpCallback(raw, expected) {
  const target = new URL(raw), original = new URL(expected);
  if (!['http:', 'https:'].includes(target.protocol) || target.origin !== original.origin || target.pathname !== original.pathname || target.hash || target.username || target.password) throw new Error('MCP_CALLBACK');
  if (target.protocol === 'http:' && !['localhost', '127.0.0.1', '[::1]'].includes(target.hostname)) throw new Error('MCP_CALLBACK');
  for (const [key, value] of original.searchParams) {
    if (!target.searchParams.getAll(key).includes(value)) throw new Error('MCP_CALLBACK');
  }
  return target.href;
}
